import React from 'react';
import { useCountryAllWarehouseListQuery } from 'api';
import { ValidationErrors } from 'constants/validations';
import { Col, CountrySelect, Form, FormModal, Input, Row, Select } from 'components';
import { SHIPPING_METHOD_OPTIONS, SHIPPING_SPEED_OPTIONS } from 'staticData/form/client/shipping';
import { useAddressAddEditModal } from './useAddressAddEditModal';

const { Item } = Form;

export interface IAddressAddEditModal {
  modalState: boolean;
  onModalStateChange: () => void;
  dataToEdit?: Record<string, any>;
  clientId?: string;
}

export const AddressAddEditModal = (props: IAddressAddEditModal) => {
  const { modalState, dataToEdit, onModalStateChange, clientId } = props;
  const { data: warehouseData = [] } = useCountryAllWarehouseListQuery();
  const { onFinish, contextHolder, onCancel, form, isLoading, states, handleCountryChange } = useAddressAddEditModal({
    modalState,
    dataToEdit,
    onModalStateChange,
    clientId,
  });
  return (
    <>
      {contextHolder}
      <FormModal
        form={form}
        title={`${dataToEdit ? 'Update' : 'Add'} Shipping Address`}
        width={680}
        okText={dataToEdit ? 'Save' : 'Add'}
        open={modalState}
        isLoading={isLoading}
        onCancel={onCancel}
        onSubmit={onFinish}
      >
        <Row justify={'space-between'} gutter={[16, 16]}>
          <Col span={12}>
            <Item
              name="countryId"
              label={'Country*'}
              rules={[
                {
                  required: true,
                  message: ValidationErrors.required('Country'),
                },
              ]}
            >
              <CountrySelect
                size={'large'}
                maxTagCount={'responsive'}
                disabled={!!dataToEdit}
                onSelect={handleCountryChange}
              />
            </Item>
          </Col>
          {!!states.length && (
            <Col span={12}>
              <Item
                name="state"
                label={'State*'}
                rules={[
                  {
                    required: true,
                    message: ValidationErrors.required('State'),
                  },
                ]}
              >
                <Select options={states} disabled={!!dataToEdit} size={'large'} />
              </Item>
            </Col>
          )}
          <Col span={12}>
            <Item
              name="city"
              label={'City*'}
              rules={[
                {
                  required: true,
                  message: ValidationErrors.required('City'),
                },
              ]}
            >
              <Input size={'large'} disabled={!!dataToEdit} />
            </Item>
          </Col>
          <Col span={12}>
            <Item
              name="streetAddress"
              label={'Street Address*'}
              rules={[
                {
                  required: true,
                  message: ValidationErrors.required('Street Address'),
                },
              ]}
            >
              <Input size={'large'} />
            </Item>
          </Col>
          <Col span={12}>
            <Item
              name="zip"
              label={'ZIP*'}
              rules={[
                {
                  required: true,
                  message: ValidationErrors.required('ZIP'),
                },
              ]}
            >
              <Input size={'large'} />
            </Item>
          </Col>
          <Col span={12}>
            <Item name="warehouseId" label={'Outbound Warehouse'}>
              <Select size={'large'} options={warehouseData} />
            </Item>
          </Col>
          <Col span={12}>
            <Item name="shippingSpeed" label={'Shipping Speed'}>
              <Select size={'large'} options={SHIPPING_SPEED_OPTIONS} />
            </Item>
          </Col>
          <Col span={12}>
            <Item name="shippingMethod" label={'Shipping Method'}>
              <Select size={'large'} options={SHIPPING_METHOD_OPTIONS} />
            </Item>
          </Col>
        </Row>
      </FormModal>
    </>
  );
};
